var templateUrl = require('./modal-confirm.html');

angular.module('ciApp').component('modalConfirm', {
  templateUrl: templateUrl,
  controllerAs: '$modalConfirmCtrl',
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  },
  controller: [
    '$timeout',
    function($timeout) {
      var ctrl = this;

      ctrl.$onInit = function() {
        ctrl.item = ctrl.resolve.item;
        ctrl.message = ctrl.resolve.message;
        ctrl.buttonText = ctrl.resolve.buttonText;
        ctrl.buttonClass = ctrl.resolve.buttonClass;
      };

      ctrl.ok = function() {
        ctrl.close({ $value: ctrl.item });
      };

      ctrl.cancel = function() {
        ctrl.dismiss({ $value: 'cancel' });
      };
    }
  ]
});



// WEBPACK FOOTER //
// ./common/components/modal-confirm/modal-confirm.component.js